import DealSearchResult from './DealSearchResult';
import EmbedSizeDealSearchResult from './EmbedSizeDealSearchResult';

export { EmbedSizeDealSearchResult };
export default DealSearchResult;